// @flow

import React, { Component } from 'react';
import type { Element } from 'react';
import PropTypes from 'prop-types';
// Actions
import * as Actions from 'actionTypes';
// components
import { connect } from 'react-redux';
import isWindow from 'Common/isWindow';
// Style
import style from './style.scss';

import { viewports, newViewports } from 'proptypes/hayPropTypes';

/**
 * ViewportDetector component. It detects the current viewport of the application and it updates the store.
 */
export class ViewportDetector extends Component<*, *> {
  visibleElem: ?HTMLElement;
  getViewportSize: Function;

  /**
   * Class constructor
   * @param {object} props - passed props
   * @return {void}
   */
  constructor(props: Object) {
    super(props);
    this.getViewportSize = this.getViewportSize.bind(this);
  }

  /**
   * propTypes function
   */
  static propTypes = {
    dispatch: PropTypes.func
  };

  /**
   * It runs getViewportSize as soon as the component is mounted and it attaches the resize event listener.
   * @return {void}
   */
  componentDidMount() {
    this.getViewportSize();
    if (isWindow) {
      window.addEventListener('resize', this.getViewportSize);
    }
  }

  /**
   * It removes the resize event listener
   * @return {void}
   */
  componentWillUnmount() {
    if (isWindow) {
      window.removeEventListener('resize', this.getViewportSize);
    }
  }

  /**
   * It gets the css value of the 'content' property of the span elem and returns the value of the viewport calculated
   * by the browser using media queries.
   * @return {void}
   */
  getViewportSize() {
    if (this.visibleElem) {
      let content = window
        .getComputedStyle(this.visibleElem)
        .getPropertyValue('content')
        .replace(/"/g, '');
      if (content) {
        if (viewports.indexOf(content) > -1) {
          this.props.dispatch({
            type: Actions.GET_VIEWPORT,
            viewport: content,
            isXs: content === 'xs'
          });
        }
      } else {
        // Bug FIXED for edge.
        if (isWindow) {
          let viewport = 'xs';
          newViewports.map(media => {
            const breakpoint = Object.keys(media)[0];
            const mediaQuery = Object.values(media);
            if (window.matchMedia(mediaQuery).matches) {
              viewport = breakpoint;
            }
          });

          this.props.dispatch({
            type: Actions.GET_VIEWPORT,
            viewport: viewport,
            isXs: viewport === 'xs'
          });
        }
      }
    }
  }

  /**
   * Returns function
   * @return {void}
   */
  render(): Element<*> {
    return (
      <span
        className={style.classResponsiveness}
        ref={visibleElem => {
          this.visibleElem = visibleElem;
        }}
      />
    );
  }
}

export default connect()(ViewportDetector);



// WEBPACK FOOTER //
// ./src/Common/ViewportDetector/index.js